
import React, { Component } from 'react'
import logo from '../tempo-logo.png'
import './Intro.css'

class Intro extends Component {
    render() {
        return (
            <section className="intro">
                <div className="tempo-logo">
                    <img src={logo} alt="Logo" className="tempo-img" />
                </div>
                <p className="product-discription">
                    Rockola de vídeos de música gratis
                </p>
            </section>
        );
    }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/pages/home/sections/intro/Intro.js